import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px !important;
  padding: 5px;
  min-width: 280px;
  max-width: 280px;
  height: auto;
  align-items: center;
  background-color: #f7f7f7;
  text-align: left;
  justify-content: space-evenly;
  position: relative;

  border-bottom: 1px solid lightgrey;
  border-radius: 5px;
  box-shadow: 0 0 5px lightgrey;
`;

const Image = styled.img`
  align-items: center;
  text-align: center;
  object-fit: contain;
  width: 100%;
  height: 300px;
`;

const ProductInfo = styled.div`
  margin: 0.3em 0;
`;

const ProductLink = styled(Link)`
  text-decoration: none;
  color: #000;
  cursor: pointer;
`;

const Product = ({ item }) => {
  const [bookImg, setBookImg] = useState("");
  const [imageMain, setImageMain] = useState("");
  useEffect(() => {
    const getBookImg = async () => {
      if (item !== undefined) {
        if (
          item.img === "" &&
          item.desc.length === 13 &&
          item.category[0] === "books"
        ) {
          const bookData = await axios.get(
            `https://www.googleapis.com/books/v1/volumes?q=isbn:${item.desc}`
          );

          const img =
            bookData?.data?.items[0]?.volumeInfo?.imageLinks?.thumbnail !==
            undefined
              ? bookData.data.items[0].volumeInfo.imageLinks.thumbnail
              : bookData?.data?.items[1]?.volumeInfo?.imageLinks?.thumbnail;
          if (bookData.data.totalItems === 0 || img === undefined) {
            setBookImg("/nimage.svg");
          } else {
            setBookImg(img);
          }
        }
      }
    };

    if (
      item.category[0] === "books" &&
      (item?.img === "" || item?.img === undefined)
    ) {
      getBookImg();
      setImageMain(bookImg);
    } else {
      setImageMain(item.img);
    }
  }, [bookImg]);
  return (
    <>
      <Container>
        <ProductLink to={`/product/${item._id}`}>
          <Image src={imageMain} alt={`rent ${item.title}`} />
        </ProductLink>

        <ProductLink to={`/product/${item._id}`}>
          <ProductInfo>
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>{item.title}</p>
            <p style={{ fontSize: "1.3em" }}>
              <span style={{ fontWeight: "bold" }}>
                £{item.price.toFixed(2)}{" "}
              </span>
              <span style={{ fontSize: "0.5em" }}>per day</span>
            </p>
            <p>
              {item?.deliveryMethods?.length > 1
                ? "Delivery or collection"
                : item?.deliveryMethods?.includes("delivery")
                ? `£${item.postageCost?.toFixed(2)} delivery`
                : "Collection only"}
            </p>
          </ProductInfo>
        </ProductLink>
      </Container>
    </>
  );
};

export default Product;
